// =============================================
// HOUSEROOTED — Theme JavaScript
// =============================================

document.addEventListener('DOMContentLoaded', function () {

  // ---- Mobile Menu ----
  initMobileMenu();

  // ---- Sliders ----
  initSliders();
  initBenefitsSlider();
  initTestimonialSlider();
  initMiniSliders();

  // ---- Accordion ----
  initAccordion();

  // ---- Bundle Builder ----
  initBundleBuilder();

  // ---- Sticky ATC ----
  initStickyATC();

  // ---- Size Selector ----
  initSizeSelector();

  // ---- Countdown Timer ----
  initCountdown();

  // ---- Filter Tabs ----
  initFilterTabs();

  // ---- Mobile Bundle Drawer ----
  initMobileBundleDrawer();

  // ---- Qty Selectors ----
  initQtySelectors();
});

// =============================================
// MOBILE MENU / DRAWER
// =============================================
function initMobileMenu() {
  const menuOpen = document.getElementById('mobile-menu-open');
  const menuClose = document.getElementById('mobile-menu-close');
  const drawer = document.getElementById('mobile-drawer');
  const overlay = document.getElementById('mobile-overlay');
  const navTriggers = document.querySelectorAll('.mobile-nav-trigger');

  if (!menuOpen || !menuClose || !drawer || !overlay) return;

  // Open menu
  menuOpen.addEventListener('click', function() {
    drawer.classList.add('active');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  });

  // Close menu
  function closeMenu() {
    drawer.classList.remove('active');
    overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  menuClose.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);

  // Submenu toggles
  navTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      const submenu = this.nextElementSibling;
      if (submenu && submenu.classList.contains('mobile-submenu')) {
        this.classList.toggle('active');
        submenu.classList.toggle('active');
      }
    });
  });

  // Close on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('active')) {
      closeMenu();
    }
  });
}

// =============================================
// PRODUCT SLIDERS
// =============================================
function initSliders() {
  document.querySelectorAll('[data-slider]').forEach(function (sliderEl) {
    const track = sliderEl.querySelector('.slider-track');
    const prevBtn = sliderEl.querySelector('[data-prev]');
    const nextBtn = sliderEl.querySelector('[data-next]');
    const dotsContainer = sliderEl.querySelector('.slider-dots');
    if (!track) return;

    const cards = track.querySelectorAll('.product-card');
    if (!cards.length) return;

    const cardWidth = cards[0].offsetWidth + 20;
    let current = 0;
    const max = Math.max(0, cards.length - 4);

    // Create dots
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      for (let i = 0; i <= max; i++) {
        const dot = document.createElement('div');
        dot.className = 'slider-dot' + (i === 0 ? ' active' : '');
        dot.style.width = i === 0 ? '32px' : '12px';
        dot.addEventListener('click', () => goTo(i));
        dotsContainer.appendChild(dot);
      }
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, max));
      track.style.transform = `translateX(-${current * cardWidth}px)`;
      updateDots();
    }

    function updateDots() {
      if (!dotsContainer) return;
      dotsContainer.querySelectorAll('.slider-dot').forEach((d, i) => {
        d.classList.toggle('active', i === current);
        d.style.width = i === current ? '32px' : '12px';
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));
  });
}

// =============================================
// BENEFITS SLIDER
// =============================================
function initBenefitsSlider() {
  document.querySelectorAll('[data-benefits-slider]').forEach(function (sliderEl) {
    const track = sliderEl.querySelector('.benefits-cards');
    const prevBtn = sliderEl.querySelector('[data-benefits-prev]');
    const nextBtn = sliderEl.querySelector('[data-benefits-next]');
    if (!track) return;

    const cards = track.querySelectorAll('.benefit-card');
    if (!cards.length) return;

    const cardWidth = cards[0].offsetWidth + 16;
    let current = 0;
    const max = Math.max(0, cards.length - 3);

    function goTo(index) {
      current = Math.max(0, Math.min(index, max));
      track.style.transform = `translateX(-${current * cardWidth}px)`;
    }

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));
  });
}

// =============================================
// TESTIMONIAL SLIDER
// =============================================
function initTestimonialSlider() {
  document.querySelectorAll('[data-testimonial-slider]').forEach(function (sliderEl) {
    const slides = sliderEl.querySelectorAll('.testimonial-card');
    const counters = sliderEl.querySelectorAll('.testimonial-counter');
    const prevBtns = sliderEl.querySelectorAll('[data-test-prev]');
    const nextBtns = sliderEl.querySelectorAll('[data-test-next]');
    if (!slides.length) return;

    let current = 0;
    let autoScrollInterval;

    function show(index) {
      slides.forEach((s, i) => s.style.display = i === index ? 'grid' : 'none');
      counters.forEach(counter => counter.textContent = `${index + 1} / ${slides.length}`);
    }

    function nextSlide() {
      current = (current + 1) % slides.length;
      show(current);
    }

    function prevSlide() {
      current = (current - 1 + slides.length) % slides.length;
      show(current);
    }

    function startAutoScroll() {
      stopAutoScroll();
      autoScrollInterval = setInterval(nextSlide, 5000);
    }

    function stopAutoScroll() {
      if (autoScrollInterval) {
        clearInterval(autoScrollInterval);
      }
    }

    show(0);
    startAutoScroll();

    prevBtns.forEach(btn => btn.addEventListener('click', () => { 
      prevSlide(); 
      startAutoScroll(); 
    }));
    nextBtns.forEach(btn => btn.addEventListener('click', () => { 
      nextSlide(); 
      startAutoScroll(); 
    }));

    // Pause on hover
    sliderEl.addEventListener('mouseenter', stopAutoScroll);
    sliderEl.addEventListener('mouseleave', startAutoScroll);
  });
}

// =============================================
// MINI SLIDERS (Collection Page)
// =============================================
function initMiniSliders() {
  document.querySelectorAll('[data-mini-slider]').forEach(function (sliderEl) {
    const cards = sliderEl.querySelectorAll('.mini-product-card');
    const prevBtn = sliderEl.querySelector('[data-mini-prev]');
    const nextBtn = sliderEl.querySelector('[data-mini-next]');
    if (!cards.length) return;

    let current = 0;
    const perPage = 2;
    const max = Math.max(0, Math.ceil(cards.length / perPage) - 1);

    function show(index) {
      cards.forEach((c, i) => {
        c.style.display = (i >= index * perPage && i < (index + 1) * perPage) ? '' : 'none';
      });
    }

    show(0);
    if (prevBtn) prevBtn.addEventListener('click', () => { current = Math.max(0, current - 1); show(current); });
    if (nextBtn) nextBtn.addEventListener('click', () => { current = Math.min(max, current + 1); show(current); });
  });
}

// =============================================
// ACCORDION
// =============================================
function initAccordion() {
  document.querySelectorAll('.accordion-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      const item = this.closest('.accordion-item');
      const isOpen = item.classList.contains('open');
      item.closest('.accordion').querySelectorAll('.accordion-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });
  // Open first item by default
  document.querySelectorAll('.accordion .accordion-item:first-child').forEach(item => item.classList.add('open'));
}

// =============================================
// BUNDLE BUILDER
// =============================================
function initBundleBuilder() {
  document.querySelectorAll('[data-bundle]').forEach(function (bundleEl) {
    const desktopSlots = bundleEl.querySelectorAll('.bundle-sidebar .bundle-slot');
    const mobileSlots = bundleEl.querySelectorAll('.mobile-slots .bundle-slot');
    const allSlots = [...desktopSlots, ...mobileSlots];
    const addBtns = bundleEl.querySelectorAll('.bundle-add-product-btn');
    const addToCartBtns = bundleEl.querySelectorAll('.bundle-add-btn');
    const drawerToggle = bundleEl.querySelector('.bundle-drawer-toggle');
    const drawerContent = bundleEl.querySelector('.bundle-drawer-content');
    const bundleCount = bundleEl.querySelector('.bundle-count');
    const required = parseInt(bundleEl.dataset.bundle) || 3;
    let bundleItems = [];

    // Mobile drawer toggle
    if (drawerToggle && drawerContent) {
      drawerToggle.addEventListener('click', function() {
        this.classList.toggle('active');
        drawerContent.classList.toggle('open');
      });
    }

    addBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const card = this.closest('.bundle-product-card');
        const name = card.querySelector('.name').textContent;
        const imgSrc = card.querySelector('img') ? card.querySelector('img').src : '';
        const price = card.querySelector('.price').textContent;
        const variantSelect = card.querySelector('.bundle-weight-select');
        const variantId = variantSelect ? variantSelect.value : null;

        if (bundleItems.length >= required) {
          showNotification('Bundle is full! Remove an item first.', 'warning');
          return;
        }

        if (bundleItems.find(i => i.name === name)) {
          showNotification('This item is already in your bundle.', 'warning');
          return;
        }

        bundleItems.push({ name, imgSrc, price, variantId });
        updateBundleSlots();
        this.textContent = 'Added ✓';
        this.style.background = 'var(--color-primary)';
        setTimeout(() => { this.textContent = 'Add'; this.style.background = ''; }, 2000);
      });
    });

    function updateBundleSlots() {
      // Update both desktop and mobile slots
      [desktopSlots, mobileSlots].forEach(slots => {
        slots.forEach((slot, i) => {
          if (bundleItems[i]) {
            slot.classList.add('filled');
            slot.innerHTML = `<img src="${bundleItems[i].imgSrc}" alt="${bundleItems[i].name}"><button class="remove-btn" data-index="${i}">×</button>`;
            const removeBtn = slot.querySelector('.remove-btn');
            if (removeBtn) {
              removeBtn.addEventListener('click', () => {
                bundleItems.splice(i, 1);
                updateBundleSlots();
              });
            }
          } else {
            slot.classList.remove('filled');
            slot.innerHTML = '';
          }
        });
      });

      // Update count badge
      if (bundleCount) {
        bundleCount.textContent = bundleItems.length;
      }

      // Update all add to cart buttons
      addToCartBtns.forEach(btn => {
        const count = bundleItems.length;
        const span = btn.querySelector('span');
        if (count === required) {
          btn.style.background = 'var(--color-primary)';
          if (span) span.textContent = `Add ${required} Items to Cart`;
        } else {
          btn.style.background = '';
          if (span) span.textContent = `Add Bundle To Cart (${count}/${required})`;
        }
      });
    }

    addToCartBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        if (bundleItems.length < required) {
          showNotification(`Please select ${required - bundleItems.length} more item(s)`, 'warning');
          return;
        }

        // Add all bundle items to cart
        const items = bundleItems.map(item => ({
          id: item.variantId,
          quantity: 1
        })).filter(item => item.id);

        if (items.length === 0) {
          showNotification('Unable to add bundle to cart. Please try again.', 'error');
          return;
        }

        // Show loading state
        this.disabled = true;
        const span = this.querySelector('span');
        if (span) span.textContent = 'Adding to cart...';

        // Add items to cart using Shopify Cart API
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        })
        .then(response => response.json())
        .then(data => {
          // Apply discount code
          const discountCode = 'BUNDLE15';
          return fetch('/discount/' + discountCode)
            .then(() => data)
            .catch(() => data);
        })
        .then(() => {
          showNotification(`Bundle added to cart! 🎉 15% discount applied!`, 'success');
          bundleItems = [];
          updateBundleSlots();
          
          if (window.updateCartCount) window.updateCartCount();
          if (window.openCartDrawer) {
            setTimeout(() => window.openCartDrawer(), 500);
          }
        })
        .catch(error => {
          console.error('Error adding bundle to cart:', error);
          showNotification('Error adding bundle to cart. Please try again.', 'error');
        })
        .finally(() => {
          this.disabled = false;
          if (span) span.textContent = 'Add Bundle To Cart';
        });
      });
    });
  });
}

// =============================================
// STICKY ATC
// =============================================
function initStickyATC() {
  const stickyBar = document.querySelector('.sticky-atc');
  const buyNowBtn = document.querySelector('.btn-buy-now');
  const stickyBtn = document.querySelector('.sticky-atc-btn');
  
  if (!stickyBar) return;
  
  // Show/hide based on Buy Now button visibility
  if (buyNowBtn) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(entry => {
        // Show sticky bar when Buy Now button is NOT visible
        stickyBar.classList.toggle('visible', !entry.isIntersecting);
      });
    }, { 
      threshold: 0,
      rootMargin: '0px 0px 100px 0px' // Show a bit before it goes off screen
    });
    
    observer.observe(buyNowBtn);
  } else {
    // Fallback to product info if buy now button not found
    const productInfo = document.querySelector('.product-info');
    if (productInfo) {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(entry => {
          stickyBar.classList.toggle('visible', !entry.isIntersecting);
        });
      }, { threshold: 0.1 });
      observer.observe(productInfo);
    }
  }
  
  // Make sticky button functional
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Get the main add to cart button and trigger it
      const mainAddToCartBtn = document.querySelector('.btn-add-cart');
      if (mainAddToCartBtn) {
        // Trigger the main button's click event
        mainAddToCartBtn.click();
        
        // Wait a moment for cart to update, then open drawer
        setTimeout(function() {
          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          }
        }, 500);
      } else {
        // Fallback: try to add to cart directly
        addToCartFromSticky();
      }
    });
  }
}

// Fallback function to add to cart if main button not found
function addToCartFromSticky() {
  const form = document.querySelector('form[action*="/cart/add"]');
  if (!form) {
    console.error('No cart form found');
    return;
  }
  
  const formData = new FormData(form);
  
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    console.log('Product added to cart:', data);
    // Open cart drawer
    if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
    }
    
    // Update cart count
    updateCartCount();
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    alert('There was an error adding the product to your cart. Please try again.');
  });
}

// Update cart count in header
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCount = document.querySelector('.cart-count');
      if (cartCount) {
        cartCount.textContent = cart.item_count;
        if (cart.item_count > 0) {
          cartCount.style.display = 'flex';
        }
      }
    })
    .catch(error => console.error('Error updating cart count:', error));
}


// =============================================
// SIZE SELECTOR
// =============================================
function initSizeSelector() {
  document.querySelectorAll('.size-options').forEach(function (container) {
    container.querySelectorAll('.size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        container.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        const label = container.closest('.product-info')?.querySelector('.size-label span');
        if (label) label.textContent = this.textContent;
      });
    });
  });
}

// =============================================
// COUNTDOWN TIMER
// =============================================
function initCountdown() {
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    const target = new Date(el.dataset.countdown).getTime();

    function update() {
      const now = Date.now();
      const diff = Math.max(0, target - now);

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      const blocks = el.querySelectorAll('.timer-block span');
      if (blocks[0]) blocks[0].textContent = String(days).padStart(2, '0');
      if (blocks[1]) blocks[1].textContent = String(hours).padStart(2, '0');
      if (blocks[2]) blocks[2].textContent = String(minutes).padStart(2, '0');
      if (blocks[3]) blocks[3].textContent = String(seconds).padStart(2, '0');
    }

    update();
    setInterval(update, 1000);
  });
}

// =============================================
// FILTER TABS
// =============================================
function initFilterTabs() {
  document.querySelectorAll('.filter-tabs').forEach(function (tabs) {
    tabs.querySelectorAll('.filter-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.querySelectorAll('.filter-tab').forEach(t => t.classList.remove('active'));
        this.classList.add('active');

        const slider = tabs.closest('[data-slider]');
        if (!slider) return;
        const filterValue = this.dataset.filter;
        const cards = slider.querySelectorAll('.product-card');

        cards.forEach(card => {
          if (!filterValue || filterValue === 'all') {
            card.style.display = '';
          } else {
            const tag = card.dataset.tag || '';
            card.style.display = tag.includes(filterValue) ? '' : 'none';
          }
        });
      });
    });
  });
}

// =============================================
// MOBILE BUNDLE DRAWER
// =============================================
function initMobileBundleDrawer() {
  const drawer = document.querySelector('.mobile-bundle-drawer');
  const toggle = document.querySelector('.bundle-drawer-toggle');
  if (!drawer || !toggle) return;

  toggle.addEventListener('click', function () {
    drawer.classList.toggle('open');
    const arrow = this.querySelector('.drawer-arrow');
    if (arrow) arrow.style.transform = drawer.classList.contains('open') ? 'rotate(180deg)' : '';
  });
}

// =============================================
// QTY SELECTORS
// =============================================
function initQtySelectors() {
  document.querySelectorAll('.qty-selector').forEach(function (selector) {
    const display = selector.querySelector('.qty-display');
    const decreaseBtn = selector.querySelector('[data-decrease]');
    const increaseBtn = selector.querySelector('[data-increase]');
    if (!display) return;

    let qty = parseInt(display.textContent) || 1;

    if (decreaseBtn) decreaseBtn.addEventListener('click', () => { qty = Math.max(1, qty - 1); display.textContent = qty; });
    if (increaseBtn) increaseBtn.addEventListener('click', () => { qty++; display.textContent = qty; });
  });
}

// =============================================
// PRODUCT GALLERY
// =============================================
function initProductGallery() {
  const mainImages = document.querySelectorAll('.product-main-image');
  const thumbs = document.querySelectorAll('.product-thumbnail');

  thumbs.forEach(function (thumb, index) {
    thumb.addEventListener('click', function () {
      const targetIndex = this.getAttribute('data-thumbnail');
      
      // Update active thumbnail
      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');

      // Update active main image
      mainImages.forEach((img, imgIndex) => {
        if (imgIndex == targetIndex) {
          img.classList.add('active');
        } else {
          img.classList.remove('active');
        }
      });
    });
  });
  
  // Add swipe functionality for mobile
  const carousel = document.querySelector('.product-image-carousel');
  if (carousel && mainImages.length > 1) {
    let startX = 0;
    let currentIndex = 0;
    
    carousel.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
    });
    
    carousel.addEventListener('touchend', function(e) {
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      
      if (Math.abs(diff) > 50) { // Minimum swipe distance
        if (diff > 0 && currentIndex < mainImages.length - 1) {
          // Swipe left - next image
          currentIndex++;
        } else if (diff < 0 && currentIndex > 0) {
          // Swipe right - previous image
          currentIndex--;
        }
        
        // Update images and thumbnails
        mainImages.forEach((img, i) => {
          img.classList.toggle('active', i === currentIndex);
        });
        thumbs.forEach((thumb, i) => {
          thumb.classList.toggle('active', i === currentIndex);
        });
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', initProductGallery);

// =============================================
// NOTIFICATION
// =============================================
function showNotification(message, type = 'success') {
  const existing = document.querySelector('.hr-notification');
  if (existing) existing.remove();

  const notif = document.createElement('div');
  notif.className = 'hr-notification';
  notif.textContent = message;
  notif.style.cssText = `
    position: fixed;
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%) translateY(20px);
    background: ${type === 'success' ? 'var(--color-primary)' : '#F59E0B'};
    color: white;
    padding: 12px 24px;
    border-radius: 100px;
    font-size: 14px;
    font-weight: 600;
    z-index: 9999;
    opacity: 0;
    transition: all 0.3s ease;
    font-family: var(--font-body);
    box-shadow: 0 4px 20px rgba(0,0,0,0.2);
  `;
  document.body.appendChild(notif);
  requestAnimationFrame(() => {
    notif.style.opacity = '1';
    notif.style.transform = 'translateX(-50%) translateY(0)';
  });
  setTimeout(() => {
    notif.style.opacity = '0';
    setTimeout(() => notif.remove(), 300);
  }, 2500);
}

// =============================================
// ADD TO CART (Shopify AJAX)
// =============================================
document.addEventListener('click', function (e) {
  const atcBtn = e.target.closest('[data-add-to-cart]');
  if (!atcBtn) return;

  const variantId = atcBtn.dataset.variantId || atcBtn.closest('[data-variant-id]')?.dataset.variantId;
  const qty = parseInt(document.querySelector('.qty-display')?.textContent) || 1;

  if (!variantId) {
    showNotification('Please select a size.', 'warning');
    return;
  }

  atcBtn.disabled = true;
  atcBtn.textContent = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
    .then(r => r.json())
    .then(() => {
      showNotification('Added to cart! 🛒', 'success');
      atcBtn.disabled = false;
      atcBtn.textContent = 'Add To Cart';
      updateCartCount();
      
      // Refresh cart drawer content and open it
      if (typeof window.openCartDrawer === 'function') {
        fetch(window.location.href)
          .then(response => response.text())
          .then(html => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newContent = doc.querySelector('#cart-drawer-content');
            var currentContent = document.querySelector('#cart-drawer-content');
            
            if (newContent && currentContent) {
              currentContent.innerHTML = newContent.innerHTML;
            }
            
            // Open the drawer after content is updated
            setTimeout(window.openCartDrawer, 100);
          })
          .catch(function() {
            // Fallback: just open the drawer
            window.openCartDrawer();
          });
      }
    })
    .catch(() => {
      atcBtn.disabled = false;
      atcBtn.textContent = 'Add To Cart';
    });
});

function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const count = document.querySelector('.cart-count');
      if (count) {
        count.textContent = cart.item_count;
        count.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    });
}

// Quick Add to Cart for Mobile
function addToCartQuick(event, variantId) {
  event.preventDefault();
  event.stopPropagation();
  
  const button = event.currentTarget;
  const originalHTML = button.innerHTML;
  
  // Loading state
  button.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="10" opacity="0.3"/><path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" stroke-width="2" fill="none"/></svg>';
  button.disabled = true;
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(response => response.json())
  .then(() => {
    // Success - show checkmark
    button.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';
    
    // Update cart count
    if (window.updateCartCount) window.updateCartCount();
    
    // Reset after 1.5 seconds
    setTimeout(() => {
      button.innerHTML = originalHTML;
      button.disabled = false;
    }, 1500);
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    button.innerHTML = originalHTML;
    button.disabled = false;
  });
}


/* Extracted from sections/cart-drawer.liquid */
// Global functions for cart drawer
window.openCartDrawer = function() {
  console.log('[Cart Drawer] Opening...');
  var drawer = document.getElementById('cart-drawer');
  if (drawer) {
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    console.log('[Cart Drawer] Opened successfully');
  } else {
    console.error('[Cart Drawer] Element not found!');
  }
};

window.closeCartDrawer = function() {
  console.log('[Cart Drawer] Closing...');
  var drawer = document.getElementById('cart-drawer');
  if (drawer) {
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }
};

function updateCartQuantity(key, qty) {
  if (qty < 0) return;
  
  var cartItem = document.querySelector('[data-key="' + key + '"]');
  if (cartItem) {
    cartItem.style.opacity = '0.5';
  }
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(response => response.json())
  .then(cart => {
    // Fetch updated cart drawer HTML
    fetch(window.location.href)
      .then(response => response.text())
      .then(html => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newContent = doc.querySelector('#cart-drawer-content');
        var currentContent = document.querySelector('#cart-drawer-content');
        
        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
        }
        
        // Update cart count in header
        var cartCount = document.querySelector('.cart-count');
        if (cartCount) {
          cartCount.textContent = cart.item_count;
        }
      });
  })
  .catch(error => {
    console.error('Error:', error);
    if (cartItem) {
      cartItem.style.opacity = '1';
    }
  });
}

function removeCartItem(key) {
  updateCartQuantity(key, 0);
}

// Override Shopify's cart add behavior
(function() {
  console.log('[Cart Drawer] Initializing...');

  // Function to refresh cart content and open drawer
  function refreshCartAndOpen() {
    console.log('[Cart Drawer] Refreshing cart content...');
    fetch(window.location.href)
      .then(response => response.text())
      .then(html => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newContent = doc.querySelector('#cart-drawer-content');
        var currentContent = document.querySelector('#cart-drawer-content');
        
        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
          console.log('[Cart Drawer] Content refreshed');
        }
        
        // Open drawer
        setTimeout(function() {
          window.openCartDrawer();
        }, 100);
      })
      .catch(error => console.error('[Cart Drawer] Refresh error:', error));
  }

  // Listen for Shopify cart add events
  document.addEventListener('DOMContentLoaded', function() {
    console.log('[Cart Drawer] DOM loaded, setting up listeners');

    // Method 1: Intercept cart icon clicks
    document.addEventListener('click', function(e) {
      var cartLink = e.target.closest('a[href="/cart"]');
      if (cartLink) {
        e.preventDefault();
        window.openCartDrawer();
      }
    });

    // Method 2: Listen for form submissions
    document.addEventListener('submit', function(e) {
      if (e.defaultPrevented) return;

      var form = e.target;
      var action = form.getAttribute('action') || form.action;
      
      if (action && (action.includes('/cart/add') || action === '/cart/add')) {
        console.log('[Cart Drawer] Add to cart form detected');
        e.preventDefault();
        
        var formData = new FormData(form);
        var button = form.querySelector('[type="submit"]');
        var originalText = button ? button.textContent : '';
        
        if (button) {
          button.disabled = true;
          button.textContent = 'Adding...';
        }
        
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          if (!response.ok) throw new Error('Failed to add to cart');
          return response.json();
        })
        .then(data => {
          console.log('[Cart Drawer] Product added:', data);
          
          if (button) {
            button.textContent = 'Added! ✓';
            setTimeout(function() {
              button.textContent = originalText;
              button.disabled = false;
            }, 2000);
          }
          
          refreshCartAndOpen();
        })
        .catch(error => {
          console.error('[Cart Drawer] Error:', error);
          if (button) {
            button.textContent = originalText;
            button.disabled = false;
          }
          alert('Error adding to cart');
        });
        
        return false;
      }
    }); // Bubble phase allows app scripts to handle their own forms first

    // Method 3: Override fetch globally for cart adds
    var originalFetch = window.fetch;
    window.fetch = function() {
      var args = arguments;
      var url = args[0];
      
      if (typeof url === 'string' && url.includes('/cart/add')) {
        console.log('[Cart Drawer] Fetch cart/add detected');
        return originalFetch.apply(this, args).then(function(response) {
          var clonedResponse = response.clone();
          clonedResponse.json().then(function(data) {
            console.log('[Cart Drawer] Cart add via fetch successful');
            setTimeout(refreshCartAndOpen, 300);
          }).catch(function() {});
          return response;
        });
      }
      
      return originalFetch.apply(this, args);
    };

    // Close drawer handlers
    var overlay = document.getElementById('cart-drawer-overlay');
    if (overlay) {
      overlay.addEventListener('click', window.closeCartDrawer);
    }

    var closeBtn = document.getElementById('cart-drawer-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', window.closeCartDrawer);
    }

    console.log('[Cart Drawer] All listeners set up!');
  });
})();


/* Extracted from sections/cart-page.liquid */
function updateCartPageQuantity(key, qty) {
  if (qty < 0) return;
  
  // Disable all buttons during update
  var buttons = document.querySelectorAll('.cart-page-item button');
  buttons.forEach(function(btn) {
    btn.disabled = true;
    btn.style.opacity = '0.5';
  });
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(response => response.json())
  .then(cart => {
    // Reload the page to show updated cart
    window.location.reload();
  })
  .catch(error => {
    console.error('Error updating cart:', error);
    // Re-enable buttons on error
    buttons.forEach(function(btn) {
      btn.disabled = false;
      btn.style.opacity = '1';
    });
    alert('Error updating cart. Please try again.');
  });
}


/* Extracted from sections/collection-main.liquid */
(function() {
  // Sort functionality
  var sortSelect = document.getElementById('sort-by');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
    
    // Set current sort value
    var urlParams = new URLSearchParams(window.location.search);
    var currentSort = urlParams.get('sort_by');
    if (currentSort) {
      sortSelect.value = currentSort;
    }
  }
})();

// Quick add to cart functionality
function quickAddToCart(variantId, productTitle) {
  var button = event.target.closest('.quick-add-btn');
  if (!button) return;
  
  // Disable button during request
  button.disabled = true;
  var originalHTML = button.innerHTML;
  button.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation: spin 1s linear infinite;"><circle cx="12" cy="12" r="10"/></svg>';
  
  // Add to cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(response => response.json())
  .then(data => {
    // Success! Show checkmark
    button.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><path d="M20 6 9 17l-5-5"/></svg>';
    button.style.background = '#22c55e';
    
    // Update cart count if exists
    var cartCount = document.querySelector('.cart-count');
    if (cartCount) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          cartCount.textContent = cart.item_count;
          cartCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
    }
    
    // Show notification
    showAddToCartNotification(productTitle);
    
    // Reset button after 2 seconds
    setTimeout(function() {
      button.innerHTML = originalHTML;
      button.style.background = '';
      button.disabled = false;
    }, 2000);
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    button.innerHTML = originalHTML;
    button.disabled = false;
    alert('Sorry, could not add item to cart. Please try again.');
  });
}

function showAddToCartNotification(productTitle) {
  // Create notification element
  var notification = document.createElement('div');
  notification.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="flex-shrink: 0;"><path d="M20 6 9 17l-5-5"/></svg><span>' + productTitle + ' added to cart!</span>';
  notification.style.cssText = 'position: fixed; top: 20px; right: 20px; background: #22c55e; color: white; padding: 16px 20px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.15); z-index: 10000; display: flex; align-items: center; gap: 12px; font-weight: 600; animation: slideIn 0.3s ease;';
  document.body.appendChild(notification);
  
  // Remove after 3 seconds
  setTimeout(function() {
    notification.style.animation = 'slideOut 0.3s ease';
    setTimeout(function() {
      document.body.removeChild(notification);
    }, 300);
  }, 3000);
}

// Add animation styles
var style = document.createElement('style');
style.textContent = '@keyframes spin { to { transform: rotate(360deg); } } @keyframes slideIn { from { transform: translateX(400px); opacity: 0; } to { transform: translateX(0); opacity: 1; } } @keyframes slideOut { from { transform: translateX(0); opacity: 1; } to { transform: translateX(400px); opacity: 0; } }';
document.head.appendChild(style);


/* Extracted from sections/features-section.liquid */
(function() {
  const section = document.querySelector('.features-section[data-mobile-layout="horizontal"]');
  if (!section || window.innerWidth > 768) return;
  
  const grid = section.querySelector('.features-grid');
  const nav = section.querySelector('.features-nav');
  const cards = grid.querySelectorAll('.feature-card');
  
  if (!nav || cards.length === 0) return;
  
  // Create navigation dots
  cards.forEach((_, index) => {
    const dot = document.createElement('div');
    dot.className = 'features-nav-dot';
    if (index === 0) dot.classList.add('active');
    dot.addEventListener('click', () => {
      cards[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
    nav.appendChild(dot);
  });
  
  // Update active dot on scroll
  const updateActiveDot = () => {
    const scrollLeft = grid.scrollLeft;
    const cardWidth = cards[0].offsetWidth + 16; // card width + gap
    const activeIndex = Math.round(scrollLeft / cardWidth);
    
    nav.querySelectorAll('.features-nav-dot').forEach((dot, index) => {
      dot.classList.toggle('active', index === activeIndex);
    });
  };
  
  grid.addEventListener('scroll', updateActiveDot);
})();


/* Extracted from sections/footer.liquid */
// Footer Accordion for Mobile
function initFooterAccordion() {
  const triggers = document.querySelectorAll('.footer-accordion-trigger');
  
  // Close all accordions on mobile by default
  if (window.innerWidth <= 768) {
    document.querySelectorAll('.footer-accordion').forEach(acc => {
      acc.classList.remove('open');
    });
  }
  
  triggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      // Only work on mobile screens
      if (window.innerWidth > 768) return;
      
      e.preventDefault();
      e.stopPropagation();
      
      const parent = this.closest('.footer-accordion');
      const isOpen = parent.classList.contains('open');
      
      // Toggle current accordion
      if (isOpen) {
        parent.classList.remove('open');
      } else {
        // Close all other accordions
        document.querySelectorAll('.footer-accordion').forEach(acc => {
          acc.classList.remove('open');
        });
        // Open current
        parent.classList.add('open');
      }
    });
  });
  
  // Handle window resize
  window.addEventListener('resize', function() {
    if (window.innerWidth > 768) {
      // Desktop: show all content
      document.querySelectorAll('.footer-accordion').forEach(acc => {
        acc.classList.add('open');
      });
    } else {
      // Mobile: close all
      document.querySelectorAll('.footer-accordion').forEach(acc => {
        acc.classList.remove('open');
      });
    }
  });
}

// Initialize on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFooterAccordion);
} else {
  initFooterAccordion();
}


/* Extracted from sections/header.liquid */
(function() {
  function initMobileMenu() {
    var openBtn = document.getElementById('mobile-menu-open');
    var closeBtn = document.getElementById('mobile-menu-close');
    var drawer = document.getElementById('mobile-drawer');
    var overlay = document.getElementById('mobile-overlay');
    if (!openBtn || !drawer) return;

    function openDrawer() {
      drawer.classList.add('open');
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('open');
      overlay.classList.remove('open');
      document.body.style.overflow = '';
      // Reset to main panel
      setTimeout(function() { showPanel('mobile-nav-main'); }, 350);
    }

    openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    function showPanel(id) {
      drawer.querySelectorAll('.mobile-nav-panel').forEach(function(p) {
        p.style.display = 'none';
      });
      var target = document.getElementById(id);
      if (target) target.style.display = 'flex';
    }
    showPanel('mobile-nav-main');

    // Trigger buttons -> sub panels
    drawer.querySelectorAll('.mobile-nav-trigger').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var panelId = this.dataset.panel;
        showPanel(panelId);
      });
    });

    // Back buttons
    drawer.querySelectorAll('[data-back]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        showPanel('mobile-nav-main');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenu);
  } else {
    initMobileMenu();
  }
})();


/* Extracted from sections/hero-banner.liquid */
(function() {
  function initHeroSlider() {
    var slider = document.querySelector('[data-hero-slider]');
    if (!slider) return;

    var slides = slider.querySelectorAll('.hero-slide');
    var prevBtn = document.querySelector('[data-hero-prev]');
    var nextBtn = document.querySelector('[data-hero-next]');
    var dots = document.querySelectorAll('[data-hero-dot]');
    var currentSlide = 0;
    var autoplayInterval;

    function showSlide(index) {
      slides.forEach(function(slide, i) {
        slide.style.display = i === index ? 'block' : 'none';
      });
      dots.forEach(function(dot, i) {
        dot.style.background = i === index ? 'white' : 'rgba(255,255,255,0.5)';
      });
      currentSlide = index;
    }

    function nextSlide() {
      var next = (currentSlide + 1) % slides.length;
      showSlide(next);
    }

    function prevSlide() {
      var prev = (currentSlide - 1 + slides.length) % slides.length;
      showSlide(prev);
    }

    function startAutoplay() {
      autoplayInterval = setInterval(nextSlide, 5000);
    }

    function stopAutoplay() {
      clearInterval(autoplayInterval);
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { stopAutoplay(); prevSlide(); startAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { stopAutoplay(); nextSlide(); startAutoplay(); });

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        stopAutoplay();
        showSlide(i);
        startAutoplay();
      });
    });

    if (slides.length > 1) {
      startAutoplay();
      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroSlider);
  } else {
    initHeroSlider();
  }
})();


/* Extracted from snippets/cart-drawer.liquid */
// Global functions for cart drawer
window.openCartDrawer = function() {
  console.log('[Cart Drawer] Opening...');
  var drawer = document.getElementById('cart-drawer');
  if (drawer) {
    drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    console.log('[Cart Drawer] Opened successfully');
  } else {
    console.error('[Cart Drawer] Element not found!');
  }
};

window.closeCartDrawer = function() {
  console.log('[Cart Drawer] Closing...');
  var drawer = document.getElementById('cart-drawer');
  if (drawer) {
    drawer.classList.remove('open');
    document.body.style.overflow = '';
  }
};

function updateCartQuantity(key, qty) {
  if (qty < 0) return;
  
  var cartItem = document.querySelector('[data-key="' + key + '"]');
  if (cartItem) {
    cartItem.style.opacity = '0.5';
  }
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(response => response.json())
  .then(cart => {
    // Fetch updated cart drawer HTML
    fetch(window.location.href)
      .then(response => response.text())
      .then(html => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newContent = doc.querySelector('#cart-drawer-content');
        var currentContent = document.querySelector('#cart-drawer-content');
        
        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
        }
        
        // Update cart count in header
        var cartCount = document.querySelector('.cart-count');
        if (cartCount) {
          cartCount.textContent = cart.item_count;
        }
      });
  })
  .catch(error => {
    console.error('Error:', error);
    if (cartItem) {
      cartItem.style.opacity = '1';
    }
  });
}

function removeCartItem(key) {
  updateCartQuantity(key, 0);
}

// Override Shopify's cart add behavior
(function() {
  console.log('[Cart Drawer] Initializing...');

  // Function to refresh cart content and open drawer
  function refreshCartAndOpen() {
    console.log('[Cart Drawer] Refreshing cart content...');
    fetch(window.location.href)
      .then(response => response.text())
      .then(html => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newContent = doc.querySelector('#cart-drawer-content');
        var currentContent = document.querySelector('#cart-drawer-content');
        
        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
          console.log('[Cart Drawer] Content refreshed');
        }
        
        // Open drawer
        setTimeout(function() {
          window.openCartDrawer();
        }, 100);
      })
      .catch(error => console.error('[Cart Drawer] Refresh error:', error));
  }

  // Listen for Shopify cart add events
  document.addEventListener('DOMContentLoaded', function() {
    console.log('[Cart Drawer] DOM loaded, setting up listeners');

    // Method 1: Intercept cart icon clicks
    document.addEventListener('click', function(e) {
      var cartLink = e.target.closest('a[href="/cart"]');
      if (cartLink) {
        e.preventDefault();
        window.openCartDrawer();
      }
    });

    // Method 2: Listen for form submissions
    document.addEventListener('submit', function(e) {
      var form = e.target;
      var action = form.getAttribute('action') || form.action;
      
      if (action && (action.includes('/cart/add') || action === '/cart/add')) {
        if (e.defaultPrevented || form.hasAttribute('data-app-handles-submit') || form.closest('[data-shopify-app-block]')) return;
        console.log('[Cart Drawer] Add to cart form detected');
        e.preventDefault();
        
        var formData = new FormData(form);
        var button = form.querySelector('[type="submit"]');
        var originalText = button ? button.textContent : '';
        
        if (button) {
          button.disabled = true;
          button.textContent = 'Adding...';
        }
        
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => {
          if (!response.ok) throw new Error('Failed to add to cart');
          return response.json();
        })
        .then(data => {
          console.log('[Cart Drawer] Product added:', data);
          
          if (button) {
            button.textContent = 'Added! ✓';
            setTimeout(function() {
              button.textContent = originalText;
              button.disabled = false;
            }, 2000);
          }
          
          refreshCartAndOpen();
        })
        .catch(error => {
          console.error('[Cart Drawer] Error:', error);
          if (button) {
            button.textContent = originalText;
            button.disabled = false;
          }
          alert('Error adding to cart');
        });
        
        return false;
      }
    }, true); // Use capture phase

    // Method 3: Override fetch globally for cart adds
    var originalFetch = window.fetch;
    window.fetch = function() {
      var args = arguments;
      var url = args[0];
      
      if (typeof url === 'string' && url.includes('/cart/add')) {
        console.log('[Cart Drawer] Fetch cart/add detected');
        return originalFetch.apply(this, args).then(function(response) {
          var clonedResponse = response.clone();
          clonedResponse.json().then(function(data) {
            console.log('[Cart Drawer] Cart add via fetch successful');
            setTimeout(refreshCartAndOpen, 300);
          }).catch(function() {});
          return response;
        });
      }
      
      return originalFetch.apply(this, args);
    };

    // Close drawer handlers
    var overlay = document.getElementById('cart-drawer-overlay');
    if (overlay) {
      overlay.addEventListener('click', window.closeCartDrawer);
    }

    var closeBtn = document.getElementById('cart-drawer-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', window.closeCartDrawer);
    }

    console.log('[Cart Drawer] All listeners set up!');
  });
})();


/* Extracted from snippets/quick-view-modal.liquid */
function openQuickView(event, productHandle) {
  event.preventDefault();
  event.stopPropagation();
  
  const modal = document.getElementById('quick-view-modal');
  const content = document.getElementById('quick-view-content');
  
  // Show modal with loading state
  modal.classList.add('active');
  content.innerHTML = '<div style="grid-column: 1 / -1; text-align: center; padding: 60px;">Loading...</div>';
  document.body.style.overflow = 'hidden';
  
  // Fetch product data using handle
  fetch(`/products/${productHandle}.js`)
    .then(response => response.json())
    .then(product => {
      renderQuickView(product);
    })
    .catch(error => {
      console.error('Error loading product:', error);
      content.innerHTML = '<div style="grid-column: 1 / -1; text-align: center; padding: 60px;">Error loading product</div>';
    });
}

function closeQuickView() {
  const modal = document.getElementById('quick-view-modal');
  modal.classList.remove('active');
  document.body.style.overflow = '';
}

function renderQuickView(product) {
  const content = document.getElementById('quick-view-content');
  
  const badges = [];
  if (product.tags.includes('new')) badges.push('<span class="badge badge-new">New</span>');
  if (product.tags.includes('popular')) badges.push('<span class="badge badge-popular">Popular</span>');
  if (product.compare_at_price > product.price) badges.push('<span class="badge badge-sale">Sale</span>');
  
  const priceHTML = product.compare_at_price > product.price
    ? `<span class="sale">${formatMoney(product.price)}</span><span class="original">${formatMoney(product.compare_at_price)}</span>`
    : formatMoney(product.price);
  
  const images = product.images.length > 0 ? product.images : [product.featured_image];
  window.currentImageIndex = 0;
  window.productImages = images;
  
  const imageNavHTML = images.length > 1 
    ? `<div class="quick-view-image-nav">
        <button class="quick-view-nav-arrow" onclick="changeImageByIndex(-1)" ${images.length <= 1 ? 'disabled' : ''}>
          <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/></svg>
        </button>
        <span class="quick-view-counter">1/${images.length}</span>
        <button class="quick-view-nav-arrow" onclick="changeImageByIndex(1)" ${images.length <= 1 ? 'disabled' : ''}>
          <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
        </button>
      </div>`
    : '';
  
  const variants = product.variants.length > 1 
    ? `<div class="quick-view-options">
        <div class="quick-view-option-label">Size: <span id="selected-size">${product.variants[0].title}</span></div>
        <div class="quick-view-variants">
          ${product.variants.map((v, i) => 
            `<button class="quick-view-variant ${i === 0 ? 'active' : ''}" onclick="selectVariant(${v.id}, '${v.title}', this)">${v.title}</button>`
          ).join('')}
        </div>
      </div>`
    : '';
  
  content.innerHTML = `
    <div class="quick-view-badges">${badges.join('')}</div>
    <h2 class="quick-view-title">${product.title}</h2>
    <div class="quick-view-price">${priceHTML}</div>
    
    <div class="quick-view-gallery">
      <div class="quick-view-main-image" id="quick-view-main-image">
        <img src="${images[0]}" alt="${product.title}">
        ${imageNavHTML}
      </div>
    </div>
    
    <div class="quick-view-description">${product.description || ''}</div>
    
    ${variants}
    
    <div class="quick-view-stock">
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>
      In stock and ready to ship
    </div>
    
    <div class="quick-view-quantity">
      <div class="quick-view-qty-selector">
        <button class="quick-view-qty-btn" onclick="updateQuickViewQty(-1)">−</button>
        <input type="number" class="quick-view-qty-input" id="quick-view-qty" value="1" min="1" readonly>
        <button class="quick-view-qty-btn" onclick="updateQuickViewQty(1)">+</button>
      </div>
    </div>
    
    <div class="quick-view-actions">
      <button class="quick-view-add-to-cart" onclick="addToCartFromQuickView(${product.variants[0].id})">Add To Cart</button>
      <button class="quick-view-buy-now" onclick="buyNowFromQuickView(${product.variants[0].id})">Buy It Now</button>
    </div>
    
    <a href="${product.url}" class="quick-view-more-details">
      View more details
      <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 18 6-6-6-6"/></svg>
    </a>
  `;
  
  window.selectedVariantId = product.variants[0].id;
}

function changeQuickViewImage(src, element) {
  document.getElementById('quick-view-main-image').innerHTML = `<img src="${src}" alt="Product">`;
  document.querySelectorAll('.quick-view-thumb').forEach(t => t.classList.remove('active'));
  element.classList.add('active');
}

function changeImageByIndex(direction) {
  const images = window.productImages;
  if (!images || images.length <= 1) return;
  
  window.currentImageIndex = (window.currentImageIndex + direction + images.length) % images.length;
  const newImage = images[window.currentImageIndex];
  
  // Update image
  const imgElement = document.querySelector('#quick-view-main-image img');
  imgElement.src = newImage;
  
  // Update counter
  const counter = document.querySelector('.quick-view-counter');
  if (counter) {
    counter.textContent = `${window.currentImageIndex + 1}/${images.length}`;
  }
}

function selectVariant(variantId, title, element) {
  window.selectedVariantId = variantId;
  document.getElementById('selected-size').textContent = title;
  document.querySelectorAll('.quick-view-variant').forEach(v => v.classList.remove('active'));
  element.classList.add('active');
}

function updateQuickViewQty(change) {
  const input = document.getElementById('quick-view-qty');
  const newQty = Math.max(1, parseInt(input.value) + change);
  input.value = newQty;
}

function addToCartFromQuickView(variantId) {
  const qty = document.getElementById('quick-view-qty').value;
  const button = event.target;
  const originalText = button.textContent;
  
  button.disabled = true;
  button.textContent = 'Adding...';
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: window.selectedVariantId || variantId, quantity: parseInt(qty) })
  })
  .then(response => response.json())
  .then(() => {
    button.textContent = 'Added! ✓';
    
    // Close quick view
    closeQuickView();
    
    // Update cart drawer content
    fetch(window.location.href)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContent = doc.querySelector('#cart-drawer-content');
        const currentContent = document.querySelector('#cart-drawer-content');
        
        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
        }
        
        // Open cart drawer
        setTimeout(() => {
          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          }
        }, 300);
      });
  })
  .catch(error => {
    console.error('Error:', error);
    button.disabled = false;
    button.textContent = originalText;
    alert('Error adding to cart');
  });
}

function buyNowFromQuickView(variantId) {
  const qty = document.getElementById('quick-view-qty').value;
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: window.selectedVariantId || variantId, quantity: parseInt(qty) })
  })
  .then(response => response.json())
  .then(() => {
    window.location.href = '/checkout';
  })
  .catch(error => console.error('Error:', error));
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}


/* Shopify storefront bootstrap */
window.Shopify = window.Shopify || {};
window.Shopify.currency = document.body.dataset.shopCurrency || '';
window.Shopify.moneyFormat = document.body.dataset.moneyFormat || '${{amount}}';


/* Reusable product-card interactions */
document.addEventListener('click', function(event) {
  var trigger = event.target.closest('[data-product-handle]');
  if (!trigger || typeof window.openQuickView !== 'function') return;
  event.preventDefault();
  window.openQuickView(event, trigger.dataset.productHandle);
});


// Enhancement: accessible dialogs, predictive search and keyboard behavior
(function(){
  const focusableSelector='a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  let lastFocused=null;
  function trapFocus(container,event){
    if(event.key!=='Tab')return; const items=[...container.querySelectorAll(focusableSelector)].filter(el=>el.offsetParent!==null); if(!items.length)return;
    const first=items[0],last=items[items.length-1]; if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()} else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}
  }
  function openDialog(dialog,trigger){ if(!dialog)return; lastFocused=trigger||document.activeElement; dialog.hidden=false; dialog.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; requestAnimationFrame(()=>{(dialog.querySelector('input,button,[tabindex]:not([tabindex="-1"])')||dialog).focus()}); }
  function closeDialog(dialog,trigger){ if(!dialog)return; dialog.setAttribute('aria-hidden','true'); dialog.hidden=true; document.body.style.overflow=''; if(trigger)trigger.setAttribute('aria-expanded','false'); if(lastFocused&&document.contains(lastFocused))lastFocused.focus(); }

  class PredictiveSearch extends HTMLElement{
    constructor(){super();this.input=this.querySelector('input[type="search"]');this.results=this.querySelector('.predictive-search');this.abortController=null;this.timer=null;this.selected=-1;}
    connectedCallback(){if(!this.input||!this.results)return;this.input.addEventListener('input',()=>this.onInput());this.input.addEventListener('keydown',e=>this.onKeydown(e));document.addEventListener('click',e=>{if(!this.contains(e.target))this.close()});}
    onInput(){clearTimeout(this.timer);const term=this.input.value.trim();if(!term){this.close();return}this.timer=setTimeout(()=>this.fetchResults(term),180)}
    async fetchResults(term){if(this.abortController)this.abortController.abort();this.abortController=new AbortController();this.setAttribute('loading','');try{const url=`${window.Shopify?.routes?.root||'/'}search/suggest?q=${encodeURIComponent(term)}&resources[type]=product,collection,page,article,query&resources[limit]=6&section_id=predictive-search`;const response=await fetch(url,{signal:this.abortController.signal,headers:{Accept:'text/html'}});if(!response.ok)throw new Error(response.status);const html=await response.text();const doc=new DOMParser().parseFromString(html,'text/html');const content=doc.querySelector('#shopify-section-predictive-search')?.innerHTML||html;this.results.innerHTML=content;this.open();}catch(error){if(error.name!=='AbortError'){this.results.innerHTML='';this.close();}}finally{this.removeAttribute('loading')}}
    open(){this.results.hidden=false;this.input.setAttribute('aria-expanded','true');this.selected=-1}
    close(){this.results.hidden=true;this.input.setAttribute('aria-expanded','false');this.selected=-1}
    options(){return [...this.results.querySelectorAll('[role="option"]')]}
    onKeydown(e){const opts=this.options();if(e.key==='Escape'){this.close();return}if(!opts.length)return;if(e.key==='ArrowDown'||e.key==='ArrowUp'){e.preventDefault();this.selected=e.key==='ArrowDown'?Math.min(this.selected+1,opts.length-1):Math.max(this.selected-1,0);opts.forEach((o,i)=>o.setAttribute('aria-selected',i===this.selected?'true':'false'));opts[this.selected]?.querySelector('a')?.focus()} }
  }
  if(!customElements.get('predictive-search'))customElements.define('predictive-search',PredictiveSearch);

  document.addEventListener('DOMContentLoaded',()=>{
    const menu=document.getElementById('mobile-drawer'), overlay=document.getElementById('mobile-overlay'), openBtn=document.getElementById('mobile-menu-open'), closeBtn=document.getElementById('mobile-menu-close');
    if(menu&&openBtn){openBtn.addEventListener('click',()=>{openBtn.setAttribute('aria-expanded','true');menu.setAttribute('aria-hidden','false');menu.removeAttribute('inert');if(overlay)overlay.hidden=false;setTimeout(()=>menu.focus(),0)});const close=()=>{openBtn.setAttribute('aria-expanded','false');menu.setAttribute('aria-hidden','true');menu.setAttribute('inert','');if(overlay)overlay.hidden=true};closeBtn?.addEventListener('click',close);overlay?.addEventListener('click',close);menu.addEventListener('keydown',e=>{if(e.key==='Escape'){close();openBtn.focus();return}trapFocus(menu,e)});}

    const searchDialog=document.getElementById('MobileSearchDialog');document.querySelectorAll('.mobile-search-btn').forEach(btn=>btn.addEventListener('click',()=>{btn.setAttribute('aria-expanded','true');openDialog(searchDialog,btn)}));searchDialog?.querySelector('.mobile-search-close')?.addEventListener('click',()=>closeDialog(searchDialog,document.querySelector('.mobile-search-btn[aria-expanded="true"]')));searchDialog?.addEventListener('keydown',e=>{if(e.key==='Escape')closeDialog(searchDialog,document.querySelector('.mobile-search-btn[aria-expanded="true"]'));trapFocus(searchDialog,e)});searchDialog?.addEventListener('click',e=>{if(e.target===searchDialog)closeDialog(searchDialog,document.querySelector('.mobile-search-btn[aria-expanded="true"]'))});


    document.querySelectorAll('.footer-accordion-trigger[role="button"]').forEach(trigger=>{const content=trigger.nextElementSibling;if(content){const expanded=trigger.closest('.footer-accordion')?.classList.contains('open');trigger.setAttribute('aria-expanded',expanded?'true':'false');trigger.addEventListener('click',()=>setTimeout(()=>trigger.setAttribute('aria-expanded',trigger.closest('.footer-accordion')?.classList.contains('open')?'true':'false'),0));trigger.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();trigger.click()}})}});

    document.querySelectorAll('.accordion-trigger').forEach((trigger,index)=>{const panel=trigger.nextElementSibling||trigger.closest('.accordion-item')?.querySelector('.accordion-content');if(!panel)return;const id=panel.id||`AccordionPanel-${index}`;panel.id=id;trigger.setAttribute('aria-controls',id);trigger.setAttribute('aria-expanded',trigger.closest('.accordion-item')?.classList.contains('open')?'true':'false');panel.hidden=trigger.getAttribute('aria-expanded')!=='true';trigger.addEventListener('click',()=>setTimeout(()=>{const open=trigger.closest('.accordion-item')?.classList.contains('open');trigger.setAttribute('aria-expanded',open?'true':'false');panel.hidden=!open},0));});
  });
})();
